import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ChevronLeft } from "@material-ui/icons";

const useStyles = makeStyles({
  configItem: {
    padding: "18px",
    borderRadius: "11px",
    display: "block",
  },
});

const GetConfigItem = ({ options }) => {
  const classes = useStyles();

  return (
    <Box mb={3}>
      <Link
        className={classes.configItem}
        style={{
          backgroundColor: `${options.btn_color}`,
          color: `${options.btn_text_color}`,
        }}
        to={options.show_list && `/panel/${options.url_links.show_factor_list}`}
      >
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h3">{options.btn_text}</Typography>
          <ChevronLeft />
        </Box>
      </Link>
    </Box>
  );
};
export default GetConfigItem;
